import { InvoiceActionType } from "models/actionTypes/invoiceActionTypes";
import { ContextConstants } from "utils/constants";
import { InvoiceCreateContextState } from "models/propTypes/invoicePropTypes";

export const InvoiceCreateReducer = (
  state: InvoiceCreateContextState,
  action: InvoiceActionType
): InvoiceCreateContextState => {
  switch (action.type) {
    case ContextConstants.InvoiceActions.SET_INVOICE_HTML:
      return { ...state, invoiceHtml: action.payload };
    case ContextConstants.InvoiceActions.SET_INVOICE_DATE:
      return { ...state, invoiceDate: action.payload };
    case ContextConstants.InvoiceActions.SET_DELIVERY_DATE:
      return { ...state, deliveryDate: action.payload };
    case ContextConstants.InvoiceActions.SET_RECURRING_START_DATE:
      return { ...state, recurringStartDate: action.payload };
    case ContextConstants.InvoiceActions.SET_RECURRING_FREQUENCY:
      return { ...state, recurringFrequency: action.payload };
    default:
      return state;
  }
};
